import { useQuery } from "@tanstack/react-query"

import { LibraryResponses } from "@tfg/types/endpoints/library"
import {
  orderByValidationType,
  SupplierGetQueryValidationType,
  supplierMonitoringFiltersValidationType,
} from "@tfg/types/schemas/organization/schemas"
import { fetchDataOptionsParam } from "@tfg/types/schemas/products"

import { httpClient } from "~/backend/axios.ts"

export const useListSubSuppliersQuery = ({
  fetchDataOptions,
  searchSupplier,
  filters,
  orderBy,
}: Omit<SupplierGetQueryValidationType, "filters" | "orderBy"> &
  fetchDataOptionsParam & {
    filters?: Partial<supplierMonitoringFiltersValidationType>
    orderBy?: Partial<orderByValidationType>
  }) => {
  return useQuery<LibraryResponses.SuppliersResponse>({
    queryKey: ["suppliers", fetchDataOptions, searchSupplier, filters, orderBy],

    queryFn: async () => {
      const res = await httpClient.get<LibraryResponses.SuppliersResponse>(
        "suppliers/sub-suppliers",
        {
          params: {
            ...fetchDataOptions,
            searchSupplier,
            filters:
              filters && Object.keys(filters).length > 0
                ? JSON.stringify(filters)
                : undefined,
            orderBy:
              orderBy && Object.keys(orderBy).length > 0
                ? JSON.stringify(orderBy)
                : undefined,
          },
        }
      )
      return res.data
    },
  })
}
